import { useQuery } from '@tanstack/react-query';
import { get } from '@truefit/http-utils';

export interface DispatchEmailConfig {
  id: number;
  userId: number;
  address: string;
  label: string | null;
}

export const EMAIL_CONFIG_QUERY_KEY = ['clip-dispatch', 'email'] as const;

export const useDispatchEmailConfigQuery = () =>
  useQuery({
    queryKey: EMAIL_CONFIG_QUERY_KEY,
    queryFn: async () => {
      const res = await get<DispatchEmailConfig[]>('/v1.0/clip-dispatch/email');
      return res.data;
    },
  });
